cc.SHADER_TILED_POSITION_TEXTURECOLOR = "ShaderTiledPositionTexturecolor"
cc.SHADER_TILED_POSITION_TEXTURE_COLOR_FRAG = `
varying vec4 v_fragmentColor;
varying vec2 v_texCoord;
uniform vec2 u_tiling;
uniform vec4 u_rect;

float mod_f1(float x, float y)
{
   return x - y * floor(x / y);
}

vec2 apply_tiling(vec2 pos)
{
    float width = abs(u_rect.x - u_rect.y);
    float height = abs(u_rect.z - u_rect.w);
    return vec2(u_rect.x + mod_f1((pos.x - u_rect.x) * u_tiling.x,width), u_rect.z + mod_f1((pos.y - u_rect.z) * u_tiling.y,height));
}

void main()
{
    gl_FragColor = v_fragmentColor * texture2D(CC_Texture0, apply_tiling(v_texCoord));
}
`;
cc.SHADER_TILED_POSITION_ETC_TEXTURE_COLOR_FRAG = `
varying vec4 v_fragmentColor;
varying vec2 v_texCoord;
varying vec2 v_alphaCoord;
uniform vec2 u_tiling;
uniform vec4 u_rect;

float mod_f1(float x, float y)
{
   return x - y * floor(x / y);
}

vec2 apply_tiling(vec2 pos)
{
    float width = abs(u_rect.x - u_rect.y);
    float height = abs(u_rect.z - u_rect.w);
    return vec2(u_rect.x + mod_f1((pos.x - u_rect.x) * u_tiling.x,width), u_rect.z + mod_f1((pos.y - u_rect.z) * u_tiling.y,height));
}

void main()
{
    vec2 tex = apply_tiling(v_texCoord) * vec2(1.0, 0.5);
    vec2 texA =  tex + vec2(0.0, 0.5);
    vec4 texColor = texture2D(CC_Texture0, tex);
    texColor.a = texture2D(CC_Texture0, texA).r;
    texColor.rgb = texColor.rgb * texColor.a;
    gl_FragColor = v_fragmentColor * texColor;
}
`;


cc.TiledSprite = cc.Sprite.extend({
    _tilingX: 1.0,
    _tilingY: 1.0,
    ctor: function (fileName, rect, rotated) {
        cc.Sprite.prototype.ctor.call(this, fileName, rect, rotated);
        this.initShader();
    },
    initShader: function () {
        var glprogram = cc.shaderCache.programForKey(cc.SHADER_TILED_POSITION_TEXTURECOLOR);
        if (!glprogram) {
            var glprogram = new cc.GLProgram();
            if (this._texture && this._texture.getPixelFormat() == cc.Texture2D.PIXEL_FORMAT_ETC1){
                glprogram.initWithVertexShaderByteArray(cc.SHADER_SPRITE_POSITION_TEXTURE_COLOR_VERT, cc.SHADER_TILED_POSITION_ETC_TEXTURE_COLOR_FRAG);
            }else{
                glprogram.initWithVertexShaderByteArray(cc.SHADER_SPRITE_POSITION_TEXTURE_COLOR_VERT, cc.SHADER_TILED_POSITION_TEXTURE_COLOR_FRAG);
            }
            glprogram.addAttribute(cc.ATTRIBUTE_NAME_POSITION, cc.VERTEX_ATTRIB_POSITION);
            glprogram.addAttribute(cc.ATTRIBUTE_NAME_TEX_COORD, cc.VERTEX_ATTRIB_TEX_COORDS);
            glprogram.addAttribute(cc.ATTRIBUTE_NAME_COLOR, cc.VERTEX_ATTRIB_COLOR);
            glprogram.link();
            glprogram.updateUniforms();
            glprogram._addUniformLocation('u_tiling');
            glprogram._addUniformLocation('u_rect');
            cc.shaderCache.addProgram(glprogram, cc.SHADER_TILED_POSITION_TEXTURECOLOR)
        }
        this.shaderProgram = glprogram;
    },
    setTiling: function (tilingX, tilingY) {
        this._tilingX = tilingX;
        this._tilingY = tilingY;
        this._renderCmd.updateFingerPrint();
    },
    _createRenderCmd: function() {
        return new cc.TiledSprite.WebGLRenderCmd(this);
    }
});

cc.TiledSprite.create = cc.TiledSprite.createFromFile = function (fileName, rect, rotated) {
    if (fileName && fileName[0] !== '#') {
        let frame = cc.spriteFrameCache.getSpriteFrame(fileName)
        if (frame) {
            fileName = frame
        }
    }
    return new cc.TiledSprite(fileName, rect, rotated)
}


cc.TiledSprite.WebGLRenderCmd = function(renderable) {
    cc.Sprite.WebGLRenderCmd.call(this, renderable);
    this._fingerPrint = null;
}
var proto = cc.TiledSprite.WebGLRenderCmd.prototype = Object.create(cc.Sprite.WebGLRenderCmd.prototype);
proto.constructor = cc.TiledSprite.WebGLRenderCmd;
proto.updateFingerPrint = function()
{
    let uvs = this._vertices;
    this._fingerPrint = this._node ? 
            `${uvs[0].u}-${uvs[0].v}-${uvs[3].u}-${uvs[3].v}-${this._node._tilingX}-${this._node._tilingY}` : null;
}
proto.uploadData = function(f32buffer, ui32buffer, vertexDataOffset) {
    if (this._shaderProgram) {
        let uvs = this._vertices;
        let left,right,top,bottom
        let rotated = this._node._rectRotated;
        let tx = rotated ? this._node._tilingY : this._node._tilingX;
        let ty = rotated ? this._node._tilingX : this._node._tilingY;
        if (rotated) {
            left = uvs[3].u;
            right = uvs[0].u;
            top = uvs[0].v;
            bottom = uvs[3].v;
        }else{
            left = uvs[0].u;
            right = uvs[2].u;
            top = uvs[0].v;
            bottom = uvs[3].v;
        }
        this._shaderProgram.use();
        this._shaderProgram.setUniformLocationWith2f('u_tiling', tx, ty);
        this._shaderProgram.setUniformLocationWith4f('u_rect', left, right, top , bottom);
    }
    return cc.Sprite.WebGLRenderCmd.prototype.uploadData.call(this,f32buffer, ui32buffer, vertexDataOffset)
}

proto._setTextureCoords = function(rect, needConvert) {
    if (needConvert === undefined)
        needConvert = true;
    if (needConvert)
        rect = cc.rectPointsToPixels(rect);
    var node = this._node;
    var tex = node._batchNode ? node.textureAtlas.texture : node._texture;
    var uvs = this._vertices;
    if (!tex)
        return;
    var atlasWidth = tex.pixelsWidth;
    var atlasHeight = tex.pixelsHeight;
    console.log("$$$$tile atlash ", atlasWidth, atlasHeight);
    var left, right, top, bottom, tempSwap;
    if (node._rectRotated) {
        left = (2 * rect.x + 1) / (2 * atlasWidth);
        right = left + (rect.height * 2 - 2) / (2 * atlasWidth);
        top = (2 * rect.y + 1) / (2 * atlasHeight);
        bottom = top + (rect.width * 2 - 2) / (2 * atlasHeight);
        
        if (node._flippedX) {
            tempSwap = top;
            top = bottom;
            bottom = tempSwap;
        }
        if (node._flippedY) {
            tempSwap = left;
            left = right;
            right = tempSwap;
        }
        uvs[0].u = right;
        uvs[0].v = top;
        uvs[1].u = left;
        uvs[1].v = top;
        uvs[2].u = right;
        uvs[2].v = bottom;
        uvs[3].u = left;
        uvs[3].v = bottom;
    } else {
        left = (2 * rect.x + 1) / (2 * atlasWidth);
        right = left + (rect.width * 2 - 2) / (2 * atlasWidth);
        top = (2 * rect.y + 1) / (2 * atlasHeight);
        bottom = top + (rect.height * 2 - 2) / (2 * atlasHeight);

        if (node._flippedX) {
            tempSwap = left;
            left = right;
            right = tempSwap;
        }
        if (node._flippedY) {
            tempSwap = top;
            top = bottom;
            bottom = tempSwap;
        }
        uvs[0].u = left;
        uvs[0].v = top;
        uvs[1].u = left;
        uvs[1].v = bottom;
        uvs[2].u = right;
        uvs[2].v = top;
        uvs[3].u = right;
        uvs[3].v = bottom;
    }
    console.log("$$$$tile uvs ", uvs);
}


